/**
 * Shared ThemeBlocks registration helper.
 *
 * Kept in its own dependency-free module so non-slider blocks can import it
 * without pulling the Swiper chunk (slider.js re-exports it for the sliders).
 */

"use strict"

/**
 * Register a block handler with the ThemeBlocks singleton, resolving the registry
 * safely even inside a cross-origin editor iframe (where touching `window.top`
 * throws a SecurityError that optional chaining does not catch).
 * @param {{name: string, handler: Function, params?: object}} block
 */
export const registerBlock = (block) => {
    let registry
    try {
        registry = (window.top && window.top.ThemeBlocks) || window.ThemeBlocks
    } catch (error) {
        registry = window.ThemeBlocks
    }
    if (registry) {
        registry.add(block)
    } else {
        console.error("[Theme] ThemeBlocks not available for block:", block && block.name)
    }
}
